import { SALES_AGREEMENT_DETAIL_BREADCRUMB } from '@features/TimberBuyer/SalesAgreements/constants'
import { SalesAgreementDetail } from '@features/TimberBuyer/SalesAgreements/Detail/SalesAgreementDetail'
import { createFileRoute } from '@tanstack/react-router'

export { SALES_AGREEMENT_DETAIL_BREADCRUMB } from '@features/TimberBuyer/SalesAgreements/constants'

const SalesAgreementDetailRoute: React.FC = () => {
  const { timberBuyerId, salesAgreementId } = Route.useParams()

  return <SalesAgreementDetail timberBuyerId={timberBuyerId} salesAgreementId={salesAgreementId} />
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/',
)({
  component: SalesAgreementDetailRoute,
  staticData: {
    breadcrumb: SALES_AGREEMENT_DETAIL_BREADCRUMB,
  },
})
